import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-regal-blue text-white shadow w-[100%]" }
const _hoisted_2 = { class: "w-full mx-auto max-w-screen-xl p-4 md:flex md:items-center md:justify-between" }
const _hoisted_3 = { class: "text-sm sm:text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://www.amundi.it/",
  class: "hover:underline"
}, "Amundi™", -1)
const _hoisted_5 = { class: "flex flex-wrap items-center mt-3 text-sm font-medium sm:mt-0" }

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterComponent',
  setup(__props) {

const version = ref(process.env.VUE_APP_VERSION);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.$t('footer.left_text')) + " ", 1),
        _hoisted_4,
        _createTextVNode(". All Rights Reserved. V. " + _toDisplayString(version.value), 1)
      ]),
      _createElementVNode("ul", _hoisted_5, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "privacy",
            class: "mr-4 hover:underline md:mr-6"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('footer.links.privacy')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "contacts",
            class: "hover:underline"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('footer.links.contacts')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})